import {MODAL} from 'features/modal-notch/constants';
import ItemOptionsModal from '../containers/item-options-modal/item-options-modal';
import StockMovementModal from '../containers/stock-movement-modal/stock-movement-modal';

export default {
  [MODAL.ITEM_OPTIONS_MODAL]: ItemOptionsModal,
  [MODAL.COMMERCIAL_PRODUCT_STOCK_MOVEMENT]: StockMovementModal,
};
